import { useCallback } from 'react'
import tw from 'twin.macro'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { BLOCKS } from '@contentful/rich-text-types'
import { useTranslation } from '@/utils/useTranslation'
import Link from '@/components/link-component'
import { scrollSpy } from '../utils/dom'
import { slugify } from '../utils/strings'

export default function TocNav({ id = 'toc-nav', title = '', sections, scrollToOffset = 0 }): JSX.Element {
  const { t } = useTranslation()
  if (sections) scrollSpy(id)

  return (
    <nav id={id}>
      <ul tw="list-none my-6 ">
        {title && sections && (
          <li>
            <Link to={`#${slugify(title)}`} tw="uppercase font-bold text-indigoBlue">
              {t('On this page')}
            </Link>
          </li>
        )}
        {sections
          ?.filter((section) => section.__typename === 'ContentfulComponentRichText' && section.body?.raw)
          .map((section) =>
            documentToReactComponents(
              {
                nodeType: BLOCKS.DOCUMENT,
                data: {},
                content: JSON.parse((section as Queries.ContentfulComponentRichText).body.raw).content.filter((chunk) =>
                  [BLOCKS.HEADING_2, BLOCKS.HEADING_3].includes(chunk.nodeType)
                ),
              },

              {
                renderNode: {
                  [BLOCKS.HEADING_2]: useCallback(
                    (node, children) => (
                      <li tw="pt-3 pb-2 leading-tight text-primaryBlue">
                        <Link
                          to={`#${slugify(children?.[0]?.props?.children || children?.[0])}`}
                          css={[tw`[&.active]:text-indigoBlue`]}
                          tw="hover:text-indigoBlue"
                          scrollToOffset={scrollToOffset}
                        >
                          {children}
                        </Link>
                      </li>
                    ),
                    []
                  ),
                  [BLOCKS.HEADING_3]: useCallback(
                    (node, children) => (
                      <li tw="pb-2 ml-2 text-base text-primaryBlue leading-tight">
                        <Link
                          tw="hover:text-indigoBlue"
                          to={`#${slugify(children?.[0]?.props?.children || children?.[0])}`}
                          css={[tw`[&.active]:text-indigoBlue`]}
                          scrollToOffset={scrollToOffset}
                        >
                          {children}
                        </Link>
                      </li>
                    ),
                    []
                  ),
                },
              }
            )
          )}
      </ul>
    </nav>
  )
}
